import script from "./TextSection.vue?vue&type=script&setup=true&lang=js"
export * from "./TextSection.vue?vue&type=script&setup=true&lang=js"

import "./TextSection.vue?vue&type=style&index=0&id=50f27bed&lang=scss&scoped=true"

import exportComponent from "/Users/pontiroli/Desktop/Repositories/eni/dist/eni-dist_longform-just-transition-persone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50f27bed"]])

export default __exports__